'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();

import React from 'react';
import Agencies, { Agency } from 'shared/pages/Agencies';
import { Locale, SynergiejobsDictionary } from 'shared/i18n/i18n-config';
import AppLayout from '../../../components/AppLayout';

function AgenciesPage({
  agencies,
  dictionary,
  locale,
  searchParams,
}: {
  agencies: Agency[];
  dictionary: SynergiejobsDictionary;
  locale: Locale;
  searchParams: { place: string; lat: string; lng: string; radius: string };
}): JSX.Element {
  return (
    <AppLayout
      dictionary={dictionary}
      noSpacer
      availableLocales={[
        { locale: 'nl', pathname: '/agencies' },
        { locale: 'fr', pathname: '/agencies' },
        { locale: 'en', pathname: '/agencies' },
      ]}
    >
      <Agencies locale={locale} agencies={agencies} dictionary={dictionary} query={searchParams} />
    </AppLayout>
  );
}

export default AgenciesPage;
